module.exports = __webpack_public_path__ + "static/img/c8914387c9518efdc571c204531f1c43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fw_sjgj.png
// module id = Z6P1
// module chunks = 1